<template>
  <div>
    <Pos_debt_balance_detail/>
  </div>
</template>

<script>
import Pos_debt_balance_detail from "@/components/adminArin/pos_system/product/Pos_debt_balance_detail";
export default {
  name: "PosDebtBalanceDetail",
  components: {
    Pos_debt_balance_detail
  }
}
</script>

<style scoped>

</style>
